import { render, staticRenderFns } from "./TakeSolvingItem.vue?vue&type=template&id=14157480"
import script from "./TakeSolvingItem.vue?vue&type=script&lang=ts"
export * from "./TakeSolvingItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports